import React from 'react';

import Theme from 'Theme';

import Button from 'components/Button';
import {
  Link,
  AccountName,
  BackContain,
  AddressText,
  DetailsContain,
  FadeInContainer,
  AccountContain
} from './Styled';

import { getAddress } from 'utils';

export const RegisterAccountInvite = ({ onPrev, onSubmit, onCreateAccount, invitation}) => {
  return (
    <FadeInContainer>
      <DetailsContain>
        {!!invitation &&
          <div style={{ marginBottom: '1em' }}>
            You have been invited to join:

            <AccountContain>
              <AccountName>{invitation.account.name}</AccountName>
              <AddressText>{getAddress(invitation.account)}</AddressText>
            </AccountContain>

          </div>
        }

        <Button.Default
          label={'Register'}
          onClick={onSubmit}
          color={Theme.brandColor}
        />
        <BackContain>
          <Button.Default
            border
            secondary
            label={'Back'}
            onClick={onPrev}
            color={Theme.brandColor}
          />
        </BackContain>
            <span>I want to create a  <Link href={'#'} onClick={onCreateAccount}>
              new account
            </Link></span>
      </DetailsContain>
    </FadeInContainer>
  );
}

export default RegisterAccountInvite;